import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

function SectionAppBar({location, user, isCurrentMindfileOwner, mindfile, navSection}) {
  const isMindfileMember = isCurrentMindfileOwner || (mindfile.contributors || []).some(contributor => contributor.id === user.uid);

  const getTabId = () => {
    for(let i=0; i<navSection.children.length; i++){
      const item = navSection.children[i];
      if(location.pathname.includes(item.path)){
        return item.path;
      }
      if(item.paths){
        for(let j=0; j<item.paths.length; j++){
          const path = item.paths[j];
          if(location.pathname.includes(path)){
            return item.path;
          }
        }
      }
    }
    return navSection.defaultPath;
  }

  const renderChild = (item) => {
    if((item.enabled === "owner" || item.enabled === "manage") && !isCurrentMindfileOwner){
      return null;
    }else if((item.enabled === "member" || item.enabled === "edit") && !isMindfileMember){
      return null;
    }else if(item.enabled === "admin" && !user.is_admin){
      return null;
    }else if(item.enabled === "avatar" && new Date(mindfile.created_at) > new Date("2023-11-15")) {
      return null;
    }else if(item.enabled === "user_role" && item.role !== user.role){
      return null;
    }
    return <Tab
      key={item.label}
      label={item.label}
      icon={item.icon}
      value={item.path}
      component={Link}
      to={item.path}
    />
  };

  return(
    <Tabs style={{minHeight:'72px'}} id="sectionTabs" value={getTabId()} variant="scrollable">
      {navSection.children.map(renderChild).filter(item => !!item)}
    </Tabs>
  )
}

const mapStateToProps = state => ({
  user: state.auth,
  isCurrentMindfileOwner: state.isCurrentMindfileOwner,
  mindfile: state.mindfile,
})

export default connect(mapStateToProps)(SectionAppBar)
